import React, { Component } from "react";
import { Button, Modal } from "antd";

import '../css/widget/widget.modal.css';

class WidgetModal extends Component {
    constructor(props){
        super(props);

        this.state = {
            visible: false,
            options: props.options || {},
            codeNum: 5
        }

        if( this.props.onRef )
        {
            this.props.onRef(this);
        }
    }

    open = () => {
        this.setState({visible: true});
    }

    onOkClick = (type) => () => {  
        if( this.props.isHide && type === 'onOk') return this.props.onOk();

        if( this.props[type] ) this.props[type]();
        
        this.setState({visible: false});
    }

    onClose = () => this.setState({visible: false})
    renewCode(codeNum){
        this.setState({
          codeNum: codeNum
        })
    }
    getPhoneCode(){
        let codeNum = 5
        let timer = setInterval(()=>{
          codeNum = this.state.codeNum || codeNum
          if(codeNum > 0 && codeNum <= 5){
            codeNum--
            this.renewCode(codeNum)
          }else {
            clearInterval(timer);
          }
        },1000);
    }
    render(){
       
        const {visible,codeNum} = this.state;
        const {title, okText = '同意', cancelText = '取消', isOk = true, isCancel = true, modalType = '', width, wrapClassName = '', type = '', message = '', bodyStyle={}, isNext=false, nextText='下一步', backBtn=false,backText="上一步"} = this.props.options || {};
        return <div className="swd-modal sfm-modal spj-modal spg-modal">
            <Modal
                // getContainer={false}
                visible={visible}
                title={title}
                width={width}
                height='500px'
                wrapClassName={wrapClassName}
                bodyStyle={{...bodyStyle}}
                destroyOnClose={true}
                onOk={this.onOkClick('onOk')}
                onCancel={this.onClose}
                footer={modalType === 'form' ? null : [
                    isCancel && <Button key="cancel" onClick={this.onOkClick('onCancel')}>{cancelText}</Button>,
                    backBtn && <Button key="back" onClick={()=>this.props.onOkClick('isBack')}>{backText}</Button>,
                    isNext &&  nextText !== '同意' &&  <Button key="next" type='primary' style={{background:'#3889CD'}} onClick={()=>this.props.onOkClick('isNext')}>{nextText}</Button>,
                    isNext && nextText === '同意' && <Button key="next" type='primary' disabled={codeNum>0} style={{background:codeNum>0?'#999':'#3889CD'}} onClick={()=>this.props.onOkClick('isNext')}>{nextText} <span style={{display:codeNum>0?'inline-block':'none'}}>({codeNum}S)</span></Button>,
                    isOk && <Button type='primary' style={{background:'#3889CD'}} onClick={this.onOkClick('onOk')}>{okText}</Button>,
                ]}
            >
                {
                    type === 'message' ? <div>{message}</div> : this.props.children
                }
            </Modal>
        </div>
    }
}

export default WidgetModal;